import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, PieChart, Pie, Cell } from "recharts";

const COLORS = ["hsl(var(--chart-1))","hsl(var(--chart-2))","hsl(var(--chart-3))","hsl(var(--chart-4))","hsl(var(--chart-5))"];

export default function Reports() {
  const [topC, setTopC] = useState([]);
  const [topP, setTopP] = useState([]);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/reports/top-customers").then(r => setTopC(r.data));
    api.get("/reports/top-products").then(r => setTopP(r.data));
    api.get("/dashboard/stats").then(r => setStats(r.data));
  }, []);

  return (
    <div className="space-y-6" data-testid="reports-page">
      <div>
        <div className="overline text-muted-foreground mb-2">Insights</div>
        <h1 className="font-heading text-4xl font-bold tracking-tight leading-none">Reports</h1>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card className="p-6">
          <h3 className="font-heading font-bold text-xl mb-4">Top Customers by Revenue</h3>
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={topC} layout="vertical">
              <XAxis type="number" hide />
              <YAxis type="category" dataKey="name" stroke="hsl(var(--muted-foreground))" fontSize={11} width={120} />
              <Tooltip contentStyle={{ background: 'hsl(var(--card))', border: '1px solid hsl(var(--border))' }} formatter={(v) => `₹${v?.toLocaleString("en-IN")}`} />
              <Bar dataKey="total" fill="hsl(var(--chart-1))" radius={[0,6,6,0]} />
            </BarChart>
          </ResponsiveContainer>
        </Card>
        <Card className="p-6">
          <h3 className="font-heading font-bold text-xl mb-4">Top Products by Volume</h3>
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={topP.slice(0,7)} layout="vertical">
              <XAxis type="number" hide />
              <YAxis type="category" dataKey="name" stroke="hsl(var(--muted-foreground))" fontSize={11} width={120} />
              <Tooltip contentStyle={{ background: 'hsl(var(--card))', border: '1px solid hsl(var(--border))' }} />
              <Bar dataKey="qty" fill="hsl(var(--chart-2))" radius={[0,6,6,0]} />
            </BarChart>
          </ResponsiveContainer>
        </Card>
        <Card className="p-6">
          <h3 className="font-heading font-bold text-xl mb-4">Lead Pipeline</h3>
          <ResponsiveContainer width="100%" height={280}>
            <PieChart>
              <Pie data={Object.entries(stats?.pipeline || {}).map(([k,v]) => ({name:k.replace("_"," "), value:v}))}
                cx="50%" cy="50%" innerRadius={60} outerRadius={100} paddingAngle={4} dataKey="value">
                {Object.keys(stats?.pipeline || {}).map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
              </Pie>
              <Tooltip contentStyle={{ background: 'hsl(var(--card))', border: '1px solid hsl(var(--border))' }} />
            </PieChart>
          </ResponsiveContainer>
        </Card>
        <Card className="p-6">
          <h3 className="font-heading font-bold text-xl mb-4">Monthly Sales</h3>
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={stats?.monthly_sales || []}>
              <XAxis dataKey="month" stroke="hsl(var(--muted-foreground))" fontSize={11} />
              <YAxis stroke="hsl(var(--muted-foreground))" fontSize={11} tickFormatter={(v) => `₹${(v/1000).toFixed(0)}k`} />
              <Tooltip contentStyle={{ background: 'hsl(var(--card))', border: '1px solid hsl(var(--border))' }} formatter={(v) => `₹${v?.toLocaleString("en-IN")}`} />
              <Bar dataKey="sales" fill="hsl(var(--chart-4))" radius={[6,6,0,0]} />
            </BarChart>
          </ResponsiveContainer>
        </Card>
      </div>
    </div>
  );
}
